export const newsLetterPageTemplateId = "70610a9a-72f5-40a4-b03c-250f7850f889";